const COORDINATE_DECIMALS = 5;

/**
 * Rounds a latitude, longitude or zoom to 5 decimals (about a metre), so
 * camera-driven RTK Query args stay stable between near-identical map moves.
 */
export function roundCoordinate(value: number): number {
  const factor = 10 ** COORDINATE_DECIMALS;
  return Math.round(value * factor) / factor;
}
